import { useEffect } from 'react';

export const useDocumentCssVariable = (property: string, value: string): void => {
    useEffect((): void => {
        document.documentElement.style.setProperty(property, value);
    }, [property, value]);
};
